import { CommonModule } from '@angular/common';
import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { AttachmentEffects } from '@literax/modules/documents/store/attachment/attachment.effects';
import { DocumentEffects } from '@literax/modules/documents/store/document/document.effects';
import { SignaturePositionEffects } from '@literax/modules/documents/store/signature-position/signature-position.effects';
import { SharedModule } from '@literax/modules/shared/shared.module';
import { EffectsModule } from '@ngrx/effects';
import { AttachmentComponent } from './attachment/attachment.component';
import { SignatureComponent } from './signature/signature.component';
import { SignaturesComponent } from './signatures/signatures.component';

@NgModule({
  declarations: [AttachmentComponent, SignatureComponent, SignaturesComponent],
  imports: [
    SharedModule,
    EffectsModule.forFeature([
      DocumentEffects,
      AttachmentEffects,
      SignaturePositionEffects
    ])
  ],
  exports: [
    CommonModule,
    AttachmentComponent,
    SignatureComponent,
    SignaturesComponent
  ],
  entryComponents: [],
  schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class SignaturesModule {}
